import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ColorPalette } from '../interfaces/colors.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly jsonUrl = '/assets/json/theme.json';
  constructor(private readonly http: HttpClient) {}

  getThemeColors(): Observable<ColorPalette> {
    return this.http.get<ColorPalette>(this.jsonUrl);
  }
}
